import { gql } from '@apollo/client';

export const getAgendaUser = gql /* GraphQL */ `
query GetAgendaUser($userId: ID!) {
    getAgendaUser(userId: $userId) {
      comId
      image
      isConfirmed
      language
      role
      suspended
      type
      hours
      timezone
      FCMtoken
      userId
      username
      __typename
    }
  }
  `;

// modfified to get users

export const shiftsByComId = gql/* GraphQL */ `query ShiftsByComId(
  $comId: ID!
  $filter: ModelAgendaShiftFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $startAt: ModelStringKeyConditionInput
) {
  shiftsByComId(
    comId: $comId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    startAt: $startAt
  ) {
    items {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      performance
      punctuality
      quality
      rate
      role
      shiftAppId
      shiftId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
      user {
        userId
        username
        image
        FCMtoken
      }
    }
    nextToken
    __typename
  }
}
`;

export const updateAgendaShift = gql/* GraphQL */ `mutation UpdateAgendaShift(
  $condition: ModelAgendaShiftConditionInput
  $input: UpdateAgendaShiftInput!
) {
  updateAgendaShift(condition: $condition, input: $input) {
    accepted
    comId
    confirmed
    createdAt
    deleted
    honors {
      nextToken
      __typename
    }
    info
    location
    performance
    punch {
      nextToken
      __typename
    }
    punctuality
    quality
    rate
    requests {
      nextToken
      __typename
    }
    role
    shiftApp {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    shiftAppId
    shiftId
    startAt
    stopAt
    suspended
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    username
    lat
    lng
    __typename
  }
}
`;